const DASHBOARD_ROUTES = Object.freeze({
	root: {
		name: 'Dashboard',
		path: '/dashboard',
		meta: {
			layout: 'Default',
		},
		redirect: {
			name: 'Index',
		},
		component: () => import('@/presentation/modules/dashboard/views/RootView.vue'),
	},
	indexDashboard: {
		name: 'Index',
		path: '',
		component: () => import('@/presentation/modules/dashboard/views/DashboardIndexView.vue'),
	},
	wallet: {
		name: 'DashboardWallet',
		path: 'wallet',
		component: () => import('@/presentation/modules/dashboard/views/WalletView.vue'),
		meta: {
			layout: 'Simple',
		},
	},
	creditCharge: {
		name: 'DashboardCreditCharge',
		path: 'credit-charge',
		component: () => import('@/presentation/modules/dashboard/views/CreditChargeView.vue'),
		meta: {
			layout: 'Simple',
		},
	},
	settingRoot: {
		name: 'DashboardSettingRoot',
		path: 'setting',
		component: () => import('@/presentation/modules/dashboard/views/setting/SettingRootView.vue'),
	},
	setting: {
		name: 'DashboardSetting',
		path: '',
		component: () => import('@/presentation/modules/dashboard/views/setting/SettingView.vue'),
	},

	identityInformation: {
		name: 'DashboardIdentityInformation',
		path: 'identity-information',
		component: () => import('@/presentation/modules/dashboard/views/setting/IdentityInformationView.vue'),
		meta: {
			layout: 'Simple',
		},
	},

	artists: {
		name: 'DashboardArtists',
		path: 'artists',
		component: () => import('@/presentation/modules/dashboard/views/setting/artist-view/ArtistView.vue'),
		meta: {
			layout: 'Simple',
		},
	},

	services: {
		name: 'DashboardServices',
		path: 'services',
		component: () => import('@/presentation/modules/dashboard/views/setting/service-view/ServiceView.vue'),
		meta: {
			layout: 'Simple',
		},
	},

	messageManager: {
		name: 'DashboardMessageManager',
		path: 'message-manager',
		component: () => import('@/presentation/modules/dashboard/views/setting/sms-template/MessageManagerView.vue'),
		meta: {
			layout: 'Simple',
		},
	},
	category: {
		name: 'DashboarCcategory',
		path: 'category',
		component: () => import('@/presentation/modules/dashboard/views/setting/CategoryView.vue'),
		meta: {
			layout: 'Simple',
		},
	},
	sendSms: {
		name: 'DashboardSendSms',
		path: 'send-sms',
		component: () => import('@/presentation/modules/dashboard/views/setting/SendSmsView.vue'),
		meta: {
			layout: 'Simple',
		},
	},

	requestRoot: {
		name: 'DashboardRequestRoot',
		path: 'requests',
		component: () => import('@/presentation/modules/dashboard/views/requests/RequestRootView.vue'),
		meta: {
			requiresAuth: true,
			layout: 'Simple',
		},
	},
	request: {
		name: 'DashboardRequests',
		path: '',
		component: () => import('@/presentation/modules/dashboard/views/requests/RequestView.vue'),
		meta: {
			layout: 'Simple',
		},
	},
	receiveRequests: {
		name: 'DashboardReceiveRequests',
		path: 'receive-requests',
		component: () => import('@/presentation/modules/dashboard/views/requests/ReceiveRequestsView.vue'),
	},
	sendRequests: {
		name: 'DashboardSendRequests',
		path: 'send-requests',
		component: () => import('@/presentation/modules/dashboard/views/requests/SendRequestsView.vue'),
	},

	bookAppointment: {
		name: 'BookAppointment',
		path: 'book',
		component: () => import('@/presentation/modules/dashboard/views/requests/BookAppointmentView.vue'),
		meta: {
			layout: 'Simple',
		},
	},

	adminRoot: {
		path: 'admin',
		name: 'DashboardAdminRoot',
		component: () => import('@/presentation/modules/dashboard/views/admin/RootView.vue'),
	},

	adminIndex: {
		name: 'DashboardAdmin',
		path: '',
		meta: {
			layout: 'Simple',
			requiresAuth: true,
		},
		component: () => import('@/presentation/modules/dashboard/views/admin/AdminIndexView.vue'),
	},

	adminBusiness: {
		name: 'DashboardAdminBusiness',
		path: 'business',
		meta: {
			layout: 'Simple',
		},
		component: () => import('@/presentation/modules/dashboard/views/admin/BusinessView.vue'),
	},
});

export default DASHBOARD_ROUTES;
